import { ROUTER_PATH } from "@config/router";

/** `/goal` — My Goals 列表 */
export const buildGoalHomePath = (): string => ROUTER_PATH.GOAL;

/** `/goal/:id` — path segment 使用 encodeURIComponent */
export const buildGoalDetailPath = (goalId: string): string =>
  `${ROUTER_PATH.GOAL}/${encodeURIComponent(goalId)}`;
